module.exports = __webpack_public_path__ + "img/11passenger_parked.0916d236.svg";